export default {
  chooseReplacement: {
    id: 'cart_replace_cta',
    defaultMessage: 'Choose replacement',
  },
}
